export default "__VITE_ASSET__DUqJVfyi__"